import { atom } from "recoil"

const authState = atom({
  key: "auth",
  default: localStorage.getItem("admin") ? true : false,
})

export default authState
